<script lang="ts">import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
export let image = '/static/icons/icon-ticketmaster.png';
export let label = "";
export let backgroundColor = "white";
export let borderColor = "#D8D8D8";
export let textColor = "black";
export let connected = false;
export let onConnect = () => { };
export let sources;
</script>

<div class="social-login-card-wrapper" on:click={onConnect} style={`color: ${textColor}; background-color: ${backgroundColor}; border-color: ${borderColor}`}>
    <img src={image} alt="avatar" class="account-logo" />
    {#if label}
        <span class="label">{label}</span>
    {/if}
</div>

<style>.social-login-card-wrapper {
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  padding: 2px 10px;
  cursor: pointer;
}

.account-logo {
  width: 34px;
  height: 34px;
}

.label {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  margin-left: 10px;
}</style>